import React from 'react';
import { Typography } from '@mui/material';
import StyledBox from 'views/information-module/InsuranceView/components/CoveringRoad/CoveringRoad.styles';
import { useTranslation } from 'next-i18next';
import Typography500 from 'views/common/components/UI/Typography500';

const CoveringRoad = () => {
  const { t } = useTranslation('fe_er_insurance_page');
  return (
    <StyledBox>
      <Typography500 component="h3" variant="h3" mb={2}>
        {t('fe_er_insurance_page:covering_road_header')}
      </Typography500>

      <Typography500 component="h4" variant="h4">
        {t('fe_er_insurance_page:covering_road_part1_header')}
      </Typography500>

      <Typography
        component="p"
        variant="body1"
        mb={3.2}
        dangerouslySetInnerHTML={{
          __html: t('fe_er_insurance_page:covering_road_part1_description'),
        }}
      />

      <Typography500 component="h4" variant="h4">
        {t('fe_er_insurance_page:covering_road_part2_header')}
      </Typography500>

      <Typography
        mb={3.2}
        component="p"
        variant="body1"
        dangerouslySetInnerHTML={{
          __html: t('fe_er_insurance_page:covering_road_part2_description'),
        }}
      />

      <Typography500 component="h4" variant="h4">
        {t('fe_er_insurance_page:covering_road_part3_header')}
      </Typography500>

      <Typography
        mb={3.2}
        component="p"
        variant="body1"
        dangerouslySetInnerHTML={{
          __html: t('fe_er_insurance_page:covering_road_part3_description'),
        }}
      />
    </StyledBox>
  );
};

export { CoveringRoad };
